'use client';

import dynamic from 'next/dynamic';

const AnimatedCirclesBackground = dynamic(
  () => import('@/components/AnimatedCirclesBackground'),
  { ssr: false },
);

export default function AnimatedCirclesBackgroundClient() {
  return <AnimatedCirclesBackground />;
}
